import React from 'react';
import PropTypes from 'prop-types';
import momentPropTypes from 'react-moment-proptypes';
import { Translate } from 'react-redux-i18n';
import Document from '../requestDocuments/document';
import { Tooltip } from '@material-ui/core';
import { capitalizeFirstLetter } from '../../../utils/string';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const slash = '/';
export const RequestDocumentsListView = props => {
  const isSuccess = !props.loading && !props.error && props.uploadedDocCount === props.documents.length;
  let cardHeaderColor = 'warning';
  let cardHeaderTranslation = 'request.documents.pandaDocumentsInformation';
  let lastSynchronisationDateInformationMessage;
  let lastSynchronisationDateTooltipMessage;
  if (props.areDocumentsFromOfa) {
    cardHeaderColor = 'blue';
    cardHeaderTranslation = 'request.documents.ofaDocumentsInformation';
    if (props.lastSynchronisationDate && props.lastSynchronisationDate.isValid()) {
      lastSynchronisationDateInformationMessage = capitalizeFirstLetter(props.lastSynchronisationDate.fromNow());
      lastSynchronisationDateTooltipMessage = /*#__PURE__*/_jsx(Translate, {
        value: props.synchronisationEnabled ? 'request.documents.ofaDocumentUpdateInformationTooltip' : 'request.documents.ofaDocumentUpdateDisabledTooltip',
        date: props.lastSynchronisationDate.format('DD/MM/YYYY'),
        time: props.lastSynchronisationDate.format('HH:mm')
      });
    }
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex-container space-between",
      children: [/*#__PURE__*/_jsxs("h2", {
        className: "no-wrap",
        children: [/*#__PURE__*/_jsx(Translate, {
          value: "request.page.documents"
        }), /*#__PURE__*/_jsx("span", {
          className: "separator"
        }), /*#__PURE__*/_jsx("span", {
          className: isSuccess ? 'success' : 'warning',
          children: /*#__PURE__*/_jsxs("strong", {
            children: [props.uploadedDocCount, slash, props.documents.length]
          })
        })]
      }), props.areDocumentsFromOfa && /*#__PURE__*/_jsxs("div", {
        className: "flex-container",
        children: [lastSynchronisationDateInformationMessage && lastSynchronisationDateTooltipMessage && /*#__PURE__*/_jsx(Tooltip, {
          "data-id": "last-synchronisation-date-tooltip",
          title: lastSynchronisationDateTooltipMessage,
          children: /*#__PURE__*/_jsx("span", {
            className: "information",
            style: {
              textAlign: 'end'
            },
            children: lastSynchronisationDateInformationMessage
          })
        }), /*#__PURE__*/_jsx("span", {
          className: "symbol symbol-ofa-no-text"
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "card",
      children: props.error ? /*#__PURE__*/_jsx("span", {
        "data-id": "error-message",
        children: /*#__PURE__*/_jsx(Translate, {
          value: "error.generic"
        })
      }) : props.loading ? /*#__PURE__*/_jsx("div", {
        className: "loading-overlay"
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("div", {
          className: "card inline-container column styled",
          style: {
            alignItems: 'center'
          },
          children: [/*#__PURE__*/_jsx(Translate, {
            value: cardHeaderTranslation,
            style: {
              textAlign: 'center'
            }
          }), /*#__PURE__*/_jsx("div", {
            className: cardHeaderColor,
            style: {
              paddingTop: '10px',
              borderBottom: 'solid 2px',
              width: '80%'
            }
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "flex-container column",
          children: props.documents.map((document, index) => /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Document, {
              document: document,
              fromOfa: props.areDocumentsFromOfa,
              requestId: props.requestId,
              onDocumentUpload: props.onDocumentUpload,
              isUploadVisible: props.isSubcontractor || props.isInvitingOrganisation,
              isUploadEnabled: props.isUploadEnabled
            })
          }, index))
        })]
      })
    })]
  });
};
RequestDocumentsListView.defaultProps = {
  areDocumentsFromOfa: false,
  lastSynchronisationDate: null,
  synchronisationEnabled: true,
  isUploadEnabled: true,
  loading: true,
  error: false,
  isSubcontractor: false,
  isInvitingOrganisation: false
};
RequestDocumentsListView.propTypes = {
  requestId: PropTypes.number.isRequired,
  areDocumentsFromOfa: PropTypes.bool,
  documents: PropTypes.array.isRequired,
  lastSynchronisationDate: momentPropTypes.momentObj,
  synchronisationEnabled: PropTypes.bool,
  uploadedDocCount: PropTypes.number.isRequired,
  isUploadEnabled: PropTypes.bool,
  isSubcontractor: PropTypes.bool,
  isInvitingOrganisation: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  onDocumentUpload: PropTypes.func.isRequired
};
export default RequestDocumentsListView;